import { trackSegmentEvent } from "./analytics"

import {
  ACCELERATE_EXPERIMENT_EVENT_NAME,
  PLANS_EXPERIMENT_EVENT_NAME,
} from "@constants/segmentEvents"

export interface SharedButtonClickProps {
  trackingEvent?: string
  trackingEventKey?: string
  trackingEventValue?: string
  onClick?: () => void
}

export interface buttonClickProps extends SharedButtonClickProps {
  e: React.MouseEvent<HTMLElement>
  linkUrl?: string
}

export const handleOnClick = ({
  e,
  linkUrl,
  trackingEvent,
  trackingEventKey,
  trackingEventValue,
  onClick,
}: buttonClickProps) => {
  // this is to support custom plans tracking event
  // TODO rework this to be more generic in future

  if (trackingEvent) {
    let event: Record<string, string> | undefined
    if (trackingEvent === ACCELERATE_EXPERIMENT_EVENT_NAME) {
      const urlParams = new URLSearchParams(window.location.search)
      const buuidValue = urlParams.get("buuid") || ""
      const vValue = urlParams.get("v") || ""
      const pValue = urlParams.get("p") || ""
      event = { ["buuid"]: buuidValue, ["v"]: vValue, ["p"]: pValue }
    } else if (trackingEvent === PLANS_EXPERIMENT_EVENT_NAME) {
      const urlParams = new URLSearchParams(window.location.search)
      const buuidValue = urlParams.get("buuid") || ""
      event = { ["buuid"]: buuidValue }
    } else {
      event =
        trackingEventKey && trackingEventValue
          ? { [trackingEventKey]: trackingEventValue }
          : undefined
    }

    trackSegmentEvent(trackingEvent, event)
  }

  if (onClick) {
    onClick()
  } else if (linkUrl && linkUrl.startsWith("#")) {
    e.preventDefault()
    const [scrollId, clickId] = linkUrl.includes("@")
      ? linkUrl.split("@")
      : [linkUrl, null]

    if (clickId) {
      document.getElementById(clickId)?.click()
    }

    if (scrollId !== "#") {
      document.querySelector(scrollId)?.scrollIntoView({ behavior: "smooth" })
    }
  }
}
